@if (hasContentItems()) {
    <div>
        <ap-accordion>
            @if ('klant.login.accordion.' + variant + '.item-1.title' | apContent) {
                <ap-accordion-item accordionItemTitle="{{ 'klant.login.accordion.' + variant + '.item-1.title' | apContent }}">
                    {{ 'klant.login.accordion.' + variant + '.item-1.content' | apContent }}
                </ap-accordion-item>
            }
            @if ('klant.login.accordion.' + variant + '.item-2.title' | apContent) {
                <ap-accordion-item accordionItemTitle="{{ 'klant.login.accordion.' + variant + '.item-2.title' | apContent }}">
                    {{ 'klant.login.accordion.' + variant + '.item-2.content' | apContent }}
                </ap-accordion-item>
            }
            @if ('klant.login.accordion.' + variant + '.item-3.title' | apContent) {
                <ap-accordion-item accordionItemTitle="{{ 'klant.login.accordion.' + variant + '.item-3.title' | apContent }}">
                    {{ 'klant.login.accordion.' + variant + '.item-3.content' | apContent }}
                </ap-accordion-item>
            }
            @if ('klant.login.accordion.' + variant + '.item-4.title' | apContent) {
                <ap-accordion-item accordionItemTitle="{{ 'klant.login.accordion.' + variant + '.item-4.title' | apContent }}">
                    {{ 'klant.login.accordion.' + variant + '.item-4.content' | apContent }}
                </ap-accordion-item>
            }
        </ap-accordion>
    </div>
}
